import React from 'react';
import { Input, Label } from 'reactstrap';

type InputType = 'text' | 'email' | 'password' | 'number' | 'tel' | 'date';

interface FormInputProps {
  id: string;
  label: string;
  value: string;
  onChange?: (value: string) => void;
  type?: InputType;
  readOnly?: boolean;
  required?: boolean;
  className?: string;
  hasSearchButton?: boolean;
  iconClass?: string;
  onSearchClick?: () => void;
}

const FormInput: React.FC<FormInputProps> = ({
  id,
  label,
  value,
  onChange,
  type = 'text',
  readOnly = false,
  required = false,
  className = '',
  hasSearchButton = false,
  iconClass,
  onSearchClick,
}) => {
  return (
    <div className="mb-3">
      <Label 
        htmlFor={id} 
        className={`form-label mb-0 ${required ? 'text-danger' : ''}`}
      >
        {label} {required && '*'}
      </Label>
      <div className={`${hasSearchButton ? 'd-flex' : ''}`}>
        <Input
          bsSize="sm"
          type={type}
          className={`form-control ${className}`}
          id={id}
          value={value}
          onChange={(e) => onChange?.(e.target.value)}
          readOnly={readOnly}
        />
        {hasSearchButton && (
          <button
            className="btn btn-light btn-sm ms-2"
            type="button"
            onClick={onSearchClick}
          >
            <i className={iconClass ? iconClass : 'ri-search-line'}></i>
          </button>
        )}
      </div>
    </div>
  );
};

export default FormInput; 